<template>
	<v-progress-circular :size="size" :width="width" :color="color" :indeterminate="loading || showLoading">
		<v-avatar :size="logoSize">
			<BrandLogo dark />
		</v-avatar>
	</v-progress-circular>
</template>

<script>
	import {
		mapGetters
	} from "vuex";

	export default {
		name: "BrandLogoLoader",
		inheritAttrs: false,

		props: {
			size: {
				type: Number,
				default: 150
			},
			width: {
				type: Number,
				default: 2
			},
			gutter: {
				type: Number,
				default: 10
			},
			color: {
				type: String,
				default: "primary"
			},
			showLoading: {
				type: Boolean,
				default: false
			}
		},

		data: () => ({
			interval: {},
			value: 0
		}),

		computed: {
			...mapGetters("appshell", ["isMobileDevice", "loading", "dark"]),

			logoSize() {
				return this.size - this.width - this.gutter;
			}
		}
	};
</script>

<style lang="css" scoped>

</style>